import type { DashboardOverview } from '../components/dashboard/DashboardStatsGrid';

export function getZoneCounts(overview: DashboardOverview = {}) {
  const totalZones = overview.totalZones ?? 0;
  const activeZones = overview.activeZones ?? 0;
  const inactiveZones = overview.inactiveZones ?? Math.max(0, totalZones - activeZones);

  return { totalZones, activeZones, inactiveZones };
}

/** Dashboard hint for active/total coverage zones. */
export function formatZoneHint(overview: DashboardOverview = {}): string {
  const { totalZones, activeZones, inactiveZones } = getZoneCounts(overview);

  if (totalZones <= 0) return 'No zones configured';

  if (inactiveZones <= 0) {
    return `${activeZones.toLocaleString()} active · 0 inactive`;
  }

  return `${activeZones.toLocaleString()} active · ${inactiveZones.toLocaleString()} inactive`;
}

export function formatActiveZonesValue(overview: DashboardOverview = {}): string {
  const { totalZones, activeZones } = getZoneCounts(overview);
  return `${activeZones.toLocaleString()}/${totalZones.toLocaleString()}`;
}
